import React, { Component } from 'react';

import {searchProducts} from '../actions/home';

export default class ProductSearch extends Component {
    static defaultProps = {
        territory: null
    }

    state = {
        value: '',
        products: null
    }

    handleChange = (e) => {
        this.setState({
            value: e.target.value,
            products: null
        });
    }

    findProducts = (e) => {
        e.preventDefault();

        if (!this.state.value) {
            return;
        }

        searchProducts(this.state.value, {sales_territory_rights: this.props.territory, sites: "SHOP"})
            .then(resp => {
                this.setState({
                    products: resp.data.data
                });
            })
            .catch(() => {
                this.setState({
                    products: []
                });
            });
    }

    handleItemSelect = (e) => {
        e.preventDefault();
        let item = this.state.products.find(item => item.sku === e.currentTarget.dataset.sku);
        this.props.onItemSelect({...item, qty: 1});
        this.setState({
            value: '',
            products: []
        });
        return item;
    }

    render = () => {
        return (
            <div style={{position: 'relative'}}>
                <form className="row middle-xs" onSubmit={this.findProducts}>
                    <div className="col-xs-12 col-sm-10">
                        <input ref={ref => (this._input = ref)} className="input-collapse" type="text" value={this.state.value} onChange={this.handleChange} placeholder="Search for Titles, Authors, or SKU/ISBN" />
                    </div>
                    <div className="col-xs-12 col-sm-2">
                        <button className="button" type="submit">search</button>
                    </div>
                </form>
                {this.state.products && !this.state.products.length ? <div>No Results Found</div> : null}
                {this.state.products && this.state.products.length
                    ? <ul className="list-flat results">
                        {this.state.products.map(prod => (
                            <li key={`item_${prod.sku}`} className="result-item" data-sku={prod.sku} onClick={this.handleItemSelect}>
                                <div><strong>{prod.title}</strong> ({prod.format})</div>
                                <ul className="list-flat">
                                    <li><strong>SKU:</strong> {prod.sku}</li>
                                    <li><strong>ISBN:</strong> {prod.isbn}</li>
                                </ul>
                            </li>
                        ))}
                    </ul>
                    : null
                }
            </div>
        );
    }
}
